import { createApp } from 'vue';
import { AisInstantSearch, AisHits, AisConfigure } from 'vue-instantsearch/vue3/es';
import OfferAddressesSearch from '../offers/components/offer_addresses_search.vue';

// Check if the element exists before mounting
const element = document.getElementById('offer-addresses-search-app');
if (element) {
  const offerId = element.dataset.offerId;
  
  if (offerId) {
    const app = createApp(OfferAddressesSearch, {
      offerId: parseInt(offerId),
    });
    
    // Register InstantSearch components globally for this app
    app.component('AisInstantSearch', AisInstantSearch);
    app.component('AisHits', AisHits);
    app.component('AisConfigure', AisConfigure);
    
    app.mount('#offer-addresses-search-app');
  }
}